import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnonymizationLevelOption from '../AnonymizationLevelOption';
import { anonymizationOptionsConfig } from 'configs';

import { Wrapper, Title, ImportantDescriptionSection } from './styles';

export default class AnonymizationLevelOptions extends Component {
	static propTypes = {
		data: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	state = {
		optionValue: this.props.data ? this.props.data.key : 0,
	};

	onChange = event => {
		const optionValue = Number(event.currentTarget.value) || 0;
		this.setState({ optionValue }, () => {
			this.props.onChange({
				anonymizationLevel: { key: optionValue },
				isFormValid: true,
			});
		});
	};

	render() {
		const { optionValue } = this.state;

		return (
			<Wrapper animationIndex={1}>
				<Title>Anonymization options</Title>
				<div>
					Within the AlixPartners Terms & Conditions of your Engagement Letter
					find Clause 13.3. The text is as follows:
					<ImportantDescriptionSection>
						In the performance of the Services AlixPartners may require
						provision of and/ or access to certain procurement information
						including (without limitation) pricing details and terms and
						conditions of purchase and supply (“Procurement Variables”) that
						relate to the Company’s procurement activities (“Company Procurement
						Variables”) which AlixPartners will compare, and/ or analyse in
						contrast, to Procurement Variables for the goods and/ or services to
						which the Company Procurement Variables relate that AlixPartners has
						compiled from various sources, including undertaking services for
						other entities that procure the same, or similar, goods and/ or
						services.
					</ImportantDescriptionSection>
					<br />
					<div>
						Select which option is stated within Clause 13.3, if you can find no
						Clause 13.3 select Option 4:
					</div>
					{anonymizationOptionsConfig.map((item, key) => {
						return (
							<AnonymizationLevelOption
								key={key}
								keyValue={key}
								value={item.value}
								title={item.title}
								description={item.description}
								onChange={this.onChange}
								checked={item.value === optionValue}
							/>
						);
					})}
				</div>
			</Wrapper>
		);
	}
}
